
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/why-60-percent-real-estate-leads-never-close",
      function () {
        return require("private-next-pages/webinars/why-60-percent-real-estate-leads-never-close.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/why-60-percent-real-estate-leads-never-close"])
      });
    }
  